import { render } from "./LegacyWeeklyDeviceSummaryReportSettings.vue?vue&type=template&id=23985be0"
import script from "./LegacyWeeklyDeviceSummaryReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyWeeklyDeviceSummaryReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__